import init from '../../helpers/init';
import {showAlert} from '../main';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  const downLoadPdf = '.filter-btns';

  function addTriggerToBookmarks() {
    const addmark = jQuery('a.addmark');
    const modal = jQuery('#consentRequest');
    let mark: JQuery<any>;
    $(document).on('click', 'a.addmark', (e: JQuery.ClickEvent) => {
      if (jQuery(e.currentTarget).hasClass('no-bookmark')) {
        return true;
      }

      e.preventDefault();
      let icon = jQuery(e.currentTarget);
      let id = icon.data('id');
      let agreeVal = icon.data('agree');
      let url = e.currentTarget.getAttribute('href');
      url = url + '&AGREE=' + icon.data('agree');

      if (url !== null && url !== '') {
        $.ajax({
          method: 'GET',
          url: url,
          dataType: 'json'
        }).done(function (data) {
          if (data.agree == 0 && data.add !== 1 && data.delete !== 1) {
            modal.modal('show');
            mark = jQuery(e.currentTarget);
            return;
          }
          let element = jQuery('[data-id=' + id + ']');
          if (data.add) {
            element.addClass('active');
            if(agreeVal == 'true') {
              if ($('.firm-detail-page').length) {
                if ($('.js-show-pdn-modal-for-chat').length) {
                  location.reload();
                }
                if ($('.firm-detail-page .js-add-contact').length) {
                  $('.firm-detail-page .js-add-contact').attr('data-agree', 'true');
                }
              }

              if($('.js-respond-ad-link[data-ads="'+id+'"]').length){
                $('.js-respond-ad-link[data-ads="'+id+'"]').attr('data-agree', 'true');
              }

              if ($('.ad-board-detail-page').length) {
                if ($('.js-show-pdn-modal-for-chat').length) {
                  location.reload();
                }
              }
            }

            jQuery('[data-pjax]#alph, .top-filter-row, .js-pjax-filter').submit();
          } else if (data.delete) {
            icon.data('agree', '');
            element.removeProp('data-agree');
            element.removeClass('active');

            jQuery('[data-pjax]#alph, .top-filter-row, .js-pjax-filter').submit();
          } else {
            showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
          }
        }).fail(function () {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
        });
      }
    });

    const modalButton = modal.find('[data-agree]');
    $(document).on('click', '#consentRequest [data-agree]', (e: JQuery.ClickEvent) => {
      if (mark !== undefined) {
        mark.data('agree', $(e.currentTarget).attr('data-agree'));
        mark.trigger('click');
      }
    });
  }

  addTriggerToBookmarks();

  addTriggerToAllBookmarks();

  $(downLoadPdf).on('click', '.bookmarks-download-pdf', (e: JQuery.ClickEvent) => {
    e.preventDefault();
  });

  function addTriggerToAllBookmarks() {
    const modal = jQuery('#consentRequest');
    let mark: JQuery<any>;

    $(document).on('click', '.js-add-result-to-bookmarks', (e) => {
      e.preventDefault();

      const ids = $(e.currentTarget).data('ids');
      const url = e.currentTarget.getAttribute('href');
      const AGREE = $(e.currentTarget).data('agree');

      $.ajax({
        url,
        method: 'GET',
        dataType: 'json',
        data: {
          ids,
          AGREE
        }
      }).done((data) => {
        if (data.agree == 0 && data.add !== 1) {
          $('#consentRequest').modal('show');
          mark = jQuery(e.currentTarget);
          return;
        }
        if (data.add) {
          $('.addmark').addClass('active');
          jQuery('[data-pjax]#alph, .top-filter-row, .js-pjax-filter').submit();
        } else {
          if (data.agree != 1) {
            showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!');
          }
        }
      }).fail(() => {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
      });

    });

    const modalButton = modal.find('[data-agree]');
    $(document).on('click', '#consentRequest [data-agree]', (e: JQuery.ClickEvent) => {
      if (mark !== undefined) {
        mark.data('agree', $(e.currentTarget).attr('data-agree'));
        mark.trigger('click');
      }
    });
  }

  $(document).on('click', '.js-bookmark-export-pdf', (e) => {
    e.preventDefault();

    const data = {
      'exhibitionId': $(e.currentTarget).attr('data-exh'),
      'userId': $(e.currentTarget).attr('data-user')
    };
    BX.ajax.runComponentAction('pwd:bookmarks.list', 'exportPdf', {
      data,
      mode: 'class'
    }).then((result: any) => {
      console.log(result);
      if (result.data && result.data.success) {
        const link = document.createElement('a');
        link.setAttribute('href', result.data.path);
        link.setAttribute('download', 'bookmarks.pdf');
        link.click();
        return false;
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });
});
